<template>
  <el-cascader
    :value="value"
    :placeholder="placeholder"
    :filterable="level < 4"
    separator="-"
    :options="curAddress"
    :props="cascaderProps"
    :disabled="disabled"
    @change="selectChange"
    clearable
    ref="cascader"
    @visible-change="focusInput"
    @keydown.native="handleKeyDown"
    v-bind="$attrs"
    class="address-selector"
  ></el-cascader>
</template>

<script>
import { getAllLevelAddress } from "@/utils/sheet"
import { hasOwnProperty } from "@/utils/common"
import axios from "axios"
import { getCachedObj } from "@/utils/cache"

export default {
  name: "AddressSelector",
  props: {
    value: Array,
    level: {
      type: Number,
      default: 3
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 在单选模式下，你只能选择叶子节点；而在多选模式下，勾选父节点真正选中的都是叶子节点。启用该功能后，可让父子节点取消关联，选择任意一级选项。
    checkStrictly: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      typr: String,
      default: "请选择或搜索"
    }
  },
  data() {
    return {
      curAddress: getAllLevelAddress(this.level)
    }
  },
  watch: {
    value() {
      // 由于街道是动态请求的,所以这里要在值改变的时候,尝试请求一下
      if (this.level == 4 && !this._.isEmpty(this.value)) {
        let value = this.value
        if (!this.multiple) {
          value = [value]
        }
        value.forEach(addressArr => {
          let county = this.curAddress
            .find(t => t.value == addressArr[0])
            ?.children.find(t => t.value == addressArr[1])
            ?.children.find(t => t.value == addressArr[2])
          if (county?.children || !county?.code) return
          this.getStreets(county.code).then(streets => this.$set(county, "children", streets))
        })
      }
    }
  },
  computed: {
    cascaderProps() {
      return {
        checkStrictly: this.checkStrictly,
        lazy: true,
        lazyLoad: this.addressLazyLoad,
        multiple: this.multiple
      }
    },
    inputEl() {
      return this.$refs.cascader?.$el.querySelector(".el-cascader__search-input")
    }
  },
  methods: {
    // 异步加载地址数据
    addressLazyLoad(node, resolve) {
      const { level, data } = node
      if (!data?.code || data.children) {
        resolve()
        return
      }
      this.getStreets(data.code)
        .then(streets => resolve(streets))
        .catch(err => {
          console.error(err)
          resolve()
        })
    },
    getStreets(countyCode) {
      if (!countyCode) return Promise.reject("code不合法")
      return getCachedObj({
        key: "getStreets_" + countyCode,
        reqFunc: () =>
          axios
            .get(
              `https://dm-web-bj.oss-cn-beijing.aliyuncs.com/3party/dm-addr/streets/${countyCode}.json`
            )
            .then(rsp => rsp.data.map(t => ({ label: t, value: t, leaf: true })))
      })
    },
    selectChange(val) {
      this.$refs.cascader.inputValue = ""
      this.focusInput()
      this.$emit("input", val)
      if (hasOwnProperty(this.$listeners, "change")) this.$emit("change", val)
    },
    focusInput(focus = true) {
      focus && this.inputEl?.focus()
    },
    handleKeyDown(e) {
      const cascader = this.$refs.cascader
      if (!cascader) return
      if (e.code === "Enter") {
        cascader.toggleDropDownVisible(true)
        cascader.focusFirstNode()
        cascader.handleSuggestionClick(0)
        this.$nextTick(() => this.focusInput())
      }
    },
    focus() {
      this.$refs.cascader.toggleDropDownVisible(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.address-selector {
  ::v-deep {
    .el-cascader__search-input {
      margin: 0 0 0 15px;
    }
  }
}
</style>
